module.exports = __webpack_public_path__ + "media/src/img/pay_from_phone-6aa59d8f1cc763fe9d9cda187e7ab60b.jpg";